const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m16 176v-136h-16v144a8 8 0 0 0 8 8h184v-16z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m26.343 122.343 11.314 11.314 6.533-6.533 12.5 28.125a8 8 0 0 0 11.749 3.407l18.541-12.362 19.363 19.363a8 8 0 0 0 13.176-2.923l11.381-31.307 6.587 9.223a8 8 0 0 0 6.513 3.35 7.742 7.742 0 0 0 .774-.038 8 8 0 0 0 6.51-4.651l17.08-37.576 10.636 8.512 10-12.494-13.8-11.044 16.09-35.4-14.566-6.622-14.424 31.713-13.3-10.647a8 8 0 0 0 -12.517 3.513l-10.229 28.126-15.744-22.042a8 8 0 0 0 -13.665 1.072l-11.945 23.895-16.462-10.973a8 8 0 0 0 -10.095 1l-8.994 8.995-10.038-22.588-14.622 6.5 12.538 28.21zm121.365-37.132 7.766 6.213-13.021 28.646-4.917-6.884zm-82.688 21.083 18.543 12.362a8 8 0 0 0 11.592-3.078l10.058-20.116 14.408 20.171-10.847 29.828-15.117-15.118a8 8 0 0 0 -10.094-1l-16.106 10.738-11.146-25.081z"
});

const SvgLineGraph = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 192 192",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLineGraph, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/line-graph.b4530ed1.svg";
export { ForwardRef as ReactComponent };